import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://codelabenterprise.com/content/",
  class: "body-large topMenuItem"
}, " Blog ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopMenuItem = _resolveComponent("TopMenuItem")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_TopMenuItem, {
      itemText: "Inicio",
      "item-route": "/"
    }),
    _createVNode(_component_TopMenuItem, {
      itemText: "Portafolio",
      "item-route": "/portfolio"
    }),
    _createVNode(_component_TopMenuItem, {
      itemText: "Herramientas",
      "item-route": "/optimize-image"
    }),
    _hoisted_1,
    _createVNode(_component_TopMenuItem, {
      itemText: "¿Quiénes somos?",
      "item-route": "/about"
    })
  ]))
}